"use strict";
import { tns } from "tiny-slider";

class CardsCarousel {
    constructor(campaignCardsList) {
        const self = this;
        this.prefersReducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;

        if (campaignCardsList) {
            for (let index in campaignCardsList) {
                const campaignCards = campaignCardsList[index];

                const slider = campaignCards.querySelector(
                    ".campaign-cards__list",
                );

                if (slider) {
                    const tinySlider = tns({
                        container: slider,
                        slideBy: "page",
                        autoplay: false,
                        controls: true,
                        nav: true,
                        navPosition: "bottom",
                        speed: self.prefersReducedMotion ? 0 : 250,
                        mouseDrag: true,
                        arrowKeys: true,
                        gutter: 10,
                        controlsText: ["", ""],
                        items: 1,
                        loop: false,
                        onInit: function (instance) {
                            instance.nextButton.ariaLabel = "Framåt";
                            instance.prevButton.ariaLabel = "Bakåt";
                            self.setWidths(campaignCards);
                            self.updateSlideFocusability(campaignCards);
                        },
                        responsive: {
                            390: {
                                items: 1,
                                gutter: 10,
                            },
                            768: {
                                items: 2,
                                gutter: 24,
                            },
                            992: {
                                items: 3,
                                gutter: 24,
                            },
                            1200: {
                                items: 3,
                                gutter: 24,
                            },
                        },
                    });

                    self.updateSlideFocusability(campaignCards);
                    self.setWidths(campaignCards);

                    tinySlider.events.on(
                        "newBreakpointEnd",
                        function (instance) {
                            const root =
                                instance.container.closest(".campaign-cards");
                            if (root) {
                                self.setWidths(root);
                            }
                        },
                    );
                }
            }
        }
    }

    updateSlideFocusability = (campaignCards) => {
        const focusableSelector =
            "a, button, input, select, textarea, [tabindex]";
        campaignCards
            .querySelectorAll('.tns-item[aria-hidden="true"]')
            .forEach((slide) => {
                slide
                    .querySelectorAll(focusableSelector)
                    .forEach((el) => el.setAttribute("tabindex", "-1"));
            });
        campaignCards
            .querySelectorAll('.tns-item:not([aria-hidden="true"])')
            .forEach((slide) => {
                slide
                    .querySelectorAll(focusableSelector)
                    .forEach((el) => el.removeAttribute("tabindex"));
            });
    };

    setWidths = (campaignCards) => {
        const tnsControlsElement = campaignCards.querySelector(".tns-controls");
        const tnsNavElement = campaignCards.querySelector(".tns-nav");
        const titleElement = campaignCards.querySelector(
            ".campaign-cards__title",
        );

        if (tnsControlsElement && tnsNavElement) {
            tnsControlsElement.style.gap = 0;
            tnsNavElement.style.width = "fit-content";
            tnsControlsElement.style.gap =
                tnsNavElement.getBoundingClientRect().width + 32 + "px";
            const tnsControlsElementWidth =
                tnsControlsElement.getBoundingClientRect().width;
            tnsNavElement.style.width = tnsControlsElementWidth + "px";

            if (window.innerWidth > 992) {
                const computedStyleFortitleElement =
                    window.getComputedStyle(titleElement);
                const titleMarginLeft = parseFloat(
                    computedStyleFortitleElement.marginLeft,
                );
                titleElement.style.maxWidth = `calc(100% - ${tnsControlsElementWidth + titleMarginLeft + 16}px)`;
            } else {
                titleElement.style.maxWidth = "100%";
            }
        }
    };
}
document.addEventListener("DOMContentLoaded", function () {
    const campaignCardsList = [...document.querySelectorAll(".campaign-cards")];
    if (campaignCardsList.length > 0) new CardsCarousel(campaignCardsList);
});
